module.exports = () => `pip install flagsmith
`
